import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import resultReducer from './result.reducer';
import textReducer from './text.reducer';
import avatarReducer from './avatar.redcer';

export default (history: any) => combineReducers({
    router: connectRouter(history),
    result: resultReducer,
    texttospeech: textReducer,
    avatar: avatarReducer
});